/* pantallas-alumno (B): LA VINETA Y EL SEPARADOR DIBUJADOS.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Regla fija 1 de las dos partes: nunca el caracter del punto de en medio como separador. Donde el
   diseno pide un punto, es un circulo hecho con CSS:
   - Vineta: 6 px #5A5A5A al inicio de cada renglon de las listas de las ventanas (parte 2).
   - Separador: 4 px, entre piezas de un renglon (Historial, "Past Exams"). Va con aire a los lados.
   Los dos estan escondidos del lector de pantalla: no son texto. */
import React from 'react';

export function Vineta({ testid, className = '' }) {
  return <span aria-hidden="true" data-parte="vineta" data-testid={testid} className={`inline-block w-1.5 h-1.5 shrink-0 rounded-full bg-[#5A5A5A] ${className}`.trim()} />;
}

export function PuntoSeparador({ testid, className = '' }) {
  return <span aria-hidden="true" data-parte="punto" data-testid={testid} className={`inline-block w-1 h-1 mx-1.5 shrink-0 rounded-full bg-[#5A5A5A] align-middle ${className}`.trim()} />;
}

/* Une piezas de texto con el punto dibujado entre ellas. Las vacias (null, '', false) no cuentan. Para
   el lector de pantalla las piezas se leen seguidas, separadas por una coma escondida. */
export function UnidosConPunto({ piezas = [], testid, className = '' }) {
  const vivas = (piezas || []).filter((p) => p !== null && p !== undefined && p !== false && p !== '');
  return (
    <span data-testid={testid} className={`inline-flex items-center flex-wrap min-w-0 ${className}`.trim()}>
      {vivas.map((p, i) => (
        <React.Fragment key={i}>
          {i > 0 ? <PuntoSeparador /> : null}
          {i > 0 ? <span className="sr-only">, </span> : null}
          <span className="min-w-0">{p}</span>
        </React.Fragment>
      ))}
    </span>
  );
}

/* Una lista con su vineta dibujada al inicio de cada renglon (las ventanas de Ajustes). */
export function ListaConVinetas({ renglones = [], testid, className = '', claseDelRenglon = 'text-[14px] leading-5 text-[#C8C8C8]' }) {
  return (
    <ul data-testid={testid} className={`flex flex-col gap-2 ${className}`.trim()}>
      {(renglones || []).map((r, i) => (
        <li key={i} className={`flex items-start gap-2.5 ${claseDelRenglon}`}>
          <Vineta className="mt-[7px]" />
          <span className="min-w-0">{r}</span>
        </li>
      ))}
    </ul>
  );
}
